<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Helpers
	import { real_id } from 'src/helpers/interface_helpers';

	// Design System Components
	import { ControlsContainer } from '@Shelly/shelly-design-system';

	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';

	import type { Device } from 'src/types/Device';
	import InputsReaderVisualizerV2 from 'src/components/Controls/Indicators/InputsReaderVisualizerV2.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import { devices_config } from '@devices/index';
	import { getGen1DeviceStatuses, createGen1StatusLabels } from '../../../Gen1/gen1-main-helpers';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		<DeviceLabelList {labelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div class="flex-full-height justify-content-end mt-s" slot="staticBottom">
		<ControlsContainer color="color-0">
			<InputsReaderVisualizerV2 slot="first" {device} {status} {settings} isInCard={false} />
		</ControlsContainer>
	</div>
</DeviceViewStateWrapper>
